import CustomToolTip from "../../../../../components/CustomTooltip";
import { ComplexEntityTypes } from "../../../../../utils/constants";
import { ReactComponent as WarningIcon } from "./icons/warning.svg";

const TerminatedEntities = ({ params, terminatedEntities }) => {
  const isTerminated = (params, terminatedEntities) => {
    return terminatedEntities?.some(
      (entity) => entity.id === params.row.original_unique_id
    );
  };

  const getTooltipTitle = (params, terminatedEntities) => {
    const uniqueId = params.row.original_unique_id;
    const entity = terminatedEntities?.find((entity) => entity.id === uniqueId);
    if (!entity) {
      return "";
    }
    const terminationDateStr = entity.terminationDate;
    const terminationDate = new Date(terminationDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isTerminationBeforeToday = terminationDate < today;
    const formattedDate = terminationDate.toLocaleDateString("en-GB");

    if (isTerminationBeforeToday) {
      if (params.row.entity_type === ComplexEntityTypes.USER) {
        return `According to the HR system, this user has been terminated since ${formattedDate}.`;
      } else if (params.row.entity_type === ComplexEntityTypes.HOST) {
        return `According to the HR system, this endpoint belongs to a terminated user which is in termination status since ${formattedDate}.`;
      }
    } else {
      if (params.row.entity_type === ComplexEntityTypes.USER) {
        return `According to the HR system, this user will be terminated on ${formattedDate}.`;
      } else if (params.row.entity_type === ComplexEntityTypes.HOST) {
        return `According to the HR system, this endpoint belongs to a user that will be terminated on ${formattedDate}.`;
      }
    }
    return "";
  };

  return isTerminated(params, terminatedEntities) ? (
    <CustomToolTip title={getTooltipTitle(params, terminatedEntities)}>
      <WarningIcon style={{ width: "22px", height: "22px" }} />
    </CustomToolTip>
  ) : null;
};

export default TerminatedEntities;
